import styled, {css} from 'styled-components';

const expandCss = css`
  margin-bottom: 1.5em;
  .ecr-faqItem-question {
    .expand-icon:after {
      content: '-';
    }
  }
`;

export default styled.div`
  border-top: 1px solid #002a442e;
  .ecr-faqItem-question {
    cursor: pointer;
    display: flex;
    h3 {
      flex: 1;
    }
    .expand-icon {
      min-width: 4em;
      text-align: center;
      font-weight: bolder;
      &:after {
        content: '+';
        font-weight: bolder;
        font-size: 2em;
      }
    }
  }
  .ecr-faqItem-answer {
    overflow: hidden;
    transition: max-height 0.2s linear;
    max-width: calc(100% - 6em);
  }
  ${({expand}) => (expand ? expandCss : '')}
`;
